var EPK = EPK || {};
EPK.ProductSearch = EPK.ProductSearch || {};
EPK.ProductSearch = function(){};

EPK.ProductCommon = EPK.ProductCommon || {};
EPK.ProductCommon = function(){};

EPK.ProductCommonParams = EPK.ProductCommonParams || {};

/**
 * 都道府県選択画面での選択クリック
 * @param elem
 */
EPK.ProductSearch.prototype.calcShopCountPref = function(elem) {

	var btnSearch = $('#btnSearch');
	var btnSelect = $('#btnSelect');
	var pref_cd = '';
	var target_url = '';
	var select_target_url = '';
   
    if ($.isEmptyObject($('#category_id2'))) {
        var target_url_base = '/product/' + $('#category_path').attr('value') + '/';
        var select_target_url_base = '/product/' + $('#category_path').attr('value') + '/';
    } else {
        var target_url_base = '/product/' + $('#category_path').attr('value') + '/ci' + $('#category_id2').attr('value') + '/';
        var select_target_url_base = '/product/' + $('#category_path').attr('value') + '/ci' + $('#category_id2').attr('value') + '/';
    }

	// 以下item_id存在時
	var item_id = $('#item_id').attr('value') != undefined ? $('#item_id').attr('value') : '';
	var query = item_id ? '?item_id=' + item_id : '';
	var target_url_item_base = item_id ? '/product/item/' + item_id + '/' : '';

	elem.each(function(){
		if($(this).prop('checked')){
			pref_cd = $(this).attr('id');
		}
	});

	btnSelect.parent().removeClass('disabled');
	btnSearch.parent().removeClass('disabled');

	// item_id存在時は商品TOPへ、無ければ商品リストへ
	target_url = target_url_item_base ? target_url_item_base + pref_cd + '/list' : target_url_base + pref_cd + '/list';
	select_target_url = select_target_url_base + pref_cd + '/area' + query;
	btnSelect.attr("href", select_target_url);
	btnSearch.attr("href", target_url);

	this.setLocationParamStr(btnSearch, target_url);

	return false;
};

/**
 * 市区選択画面での選択クリック
 * @param elem
 */
EPK.ProductSearch.prototype.calcShopCountCity = function(elem) {

	var btnSearch = $('#btnSearch');
	var btnSelect = $('#btnSelect');
	var shop_count = 0;
	var area_id = '';
	var city_id = '';
	var target_url = '';
	var select_target_url = '';

    if ($.isEmptyObject($('#category_id2'))) {
    	var target_url_base = '/product/'+$('#category_path').attr('value')+'/'+$('#pref_cd').attr('value')+'/list/';
    	var select_target_url_base = '/product/'+$('#category_path').attr('value')+'/'+$('#pref_cd').attr('value')+'/area/';
    } else {
        var target_url_base = '/product/' + $('#category_path').attr('value') + '/ci' + $('#category_id2').attr('value') + '/'+$('#pref_cd').attr('value')+'/list/';
        var select_target_url_base = '/product/' + $('#category_path').attr('value') + '/ci' + $('#category_id2').attr('value') + '/'+$('#pref_cd').attr('value')+'/area/';
    }
	// 以下item_id存在時
	var item_id = $('#item_id').attr('value') != undefined ? $('#item_id').attr('value') : '';
	var query = item_id ? '?item_id=' + item_id : '';
	var target_url_item_base = item_id ? '/product/item/' + item_id + '/'+$('#pref_cd').attr('value')+'/list/' : '';

	elem.each(function(){
		if($(this).prop('checked')){
			shop_count = parseInt($(this).attr('value'));
			area_id = $(this).attr('id');
			city_id = $(this).attr('city_id');
		}
	});

	if(shop_count > 0){
		btnSelect.parent().removeClass('disabled');
		btnSearch.parent().removeClass('disabled');

		// item_id存在時は商品TOPへ、無ければ商品リストへ
		target_url = target_url_base + area_id + query;
		target_url = target_url_item_base ? target_url_item_base + area_id : target_url_base + area_id;
		select_target_url = select_target_url_base + city_id + query;
		btnSelect.attr("href", select_target_url);
		btnSearch.attr("href", target_url);

		this.setLocationParamStr(btnSearch, target_url);
	}

	return false;
};

/**
 * 現在地（緯度経度）取得処理
 * ※※位置情報取得できない場合のハンドリングが必要なので
 * ※※共通処理(EPK.common.currentPlaceCallback)は利用しない
 *
 */
EPK.ProductSearch.prototype.getLocation = function(){

	current_place = $('#current_place');
	category_path = current_place.attr('data-category');
	category_id = current_place.attr('data-category-id');

	function successFunc(position) {
		var $data = position.coords ;
		var $lat = $data.latitude;
		var $lng = $data.longitude;

		// 現在地から探すリンク活性
        if ($.isEmptyObject(category_id)) {
            current_place.attr('href', '/product/' + category_path + '/near?lat=' + $lat + '&lng=' + $lng);
        } else {
            current_place.attr('href', '/product/' + category_path + '/ci' + category_id + '/near?lat=' + $lat + '&lng=' + $lng);
        }
	}

	function errorFunc() {
		// 現在地から探すリンク非活性
		current_place.attr("href", "javascript:void(0);");
		current_place.on('click', function() {
			$.magnificPopup.close();
			$.magnificPopup.open({
				items: {src: $('#modal-product-list-no-current-place')},
				type: 'inline',
				modal: false,
			}, 0);
		});
	}

	var tmpLat = Cookies.get('lat');
	var tmpLng = Cookies.get('lng');
	if(tmpLat && tmpLng) {
		successFunc({coords: {latitude: tmpLat*1.0, longitude: tmpLng*1.0}});
		return;
	}

	var optionObj = {
		"enableHighAccuracy": true,
		"timeout": 8000,
		"maximumAge": 2000,
	};

	// Geolocation APIの対応判定
	if(navigator.geolocation) {
		// 現在位置を取得
		navigator.geolocation.getCurrentPosition(successFunc, errorFunc, optionObj);
	}else {
		errorFunc();
	}
};

/**
 * 現在地（緯度経度）取得処理
 * ※※位置情報取得できない場合のハンドリングが必要なので
 * ※※共通処理(EPK.common.currentPlaceCallback)は利用しない
 *
 */
EPK.ProductSearch.prototype.setLocationParamStr = function(btnSearch, url){

	current_place = $('#current_place');
	category_path = current_place.attr('data-category');
	category_id = current_place.attr('data-category-id');
	var s = url.indexOf('?') > -1 ? '&' : '?';

	function successFunc(position) {
		var $data = position.coords ;
		var $lat = $data.latitude;
		var $lng = $data.longitude;

		doAttributeParams($lat, $lng);
	}

	function errorFunc() {
		doAttributeParams(1, 1);
	}

	function doAttributeParams(lat, lng) {
		btnSearch.attr('href', url + s + 'lat=' + lat + '&lng=' + lng + '&sort=close');
	}

	var tmpLat = Cookies.get('lat');
	var tmpLng = Cookies.get('lng');
	if(tmpLat && tmpLng) {
		successFunc({coords: {latitude: tmpLat*1.0, longitude: tmpLng*1.0}});
		return;
	}

	var optionObj = {
		"enableHighAccuracy": true,
		"timeout": 8000,
		"maximumAge": 2000,
	};

	// Geolocation APIの対応判定
	if(navigator.geolocation) {
		// 現在位置を取得
		navigator.geolocation.getCurrentPosition(successFunc, errorFunc, optionObj);
	}else {
		errorFunc();
	}
};

EPK.ProductSearch.prototype.getLocationTriggerClick = function($anchor) {

	var current_place = $anchor;
	var url = current_place.prop('href');
	var s = url.indexOf('?') > -1 ? '&' : '?';

	function successFunc(position) {
		var $data = position.coords ;
		var $lat = $data.latitude;
		var $lng = $data.longitude;
		doAddParamsAndClick($lat, $lng);
	}

	function errorFunc() {
		doAddParamsAndClick(1, 1);
	}

	function doAddParamsAndClick(lat, lng) {
		// 現在地のurl生成
		url = url + s + 'lat=' + lat + '&lng=' + lng  + '&sort=close';
		current_place.prop('href', url);
		current_place.trigger('click');
	}

	var tmpLat = Cookies.get('lat');
	var tmpLng = Cookies.get('lng');
	if(tmpLat && tmpLng) {
		successFunc({coords: {latitude: tmpLat*1.0, longitude: tmpLng*1.0}});
		return;
	}

	var optionObj = {
			"enableHighAccuracy": true,
			"timeout": 8000,
			"maximumAge": 2000,
	};

	// Geolocation APIの対応判定
	if(navigator.geolocation) {
		// 現在位置を取得
		navigator.geolocation.getCurrentPosition(successFunc, errorFunc, optionObj);
	}else {
		errorFunc();
	}
};

$(function(){
	var ProductSearch = new EPK.ProductSearch();

	/**
	 * PC版
	 */

	if(!EPK.ProductCommonParams.isSP){
		EPK.ProductCommon.getMakerItemCount(1, 1);
	}

	// 都道府県選択画面での選択クリック
	$('input[name=pref]').on('change', function() {
		ProductSearch.calcShopCountPref($('input[name=pref]'));
	});
	// ブラウザバック対応
	if ($('input[name=pref]').is(':checked')) {
		ProductSearch.calcShopCountPref($('input[name=pref]'));
	}

	// 市区選択画面での選択クリック
	$('input[name=city]').on('change', function() {
		ProductSearch.calcShopCountCity($('input[name=city]'));
	});
	// ブラウザバック対応
	if ($('input[name=city]').is(':checked')) {
		ProductSearch.calcShopCountCity($('input[name=city]'));
	}

	// 現在地から探すリンク生成
	if ($('#current_place').length) {
		ProductSearch.getLocation();
	}

	// 現在地を付与して遷移
	$('.area-list a.add-location').on('click', function(e) {
		var url = $(this).prop('href');
		if (url.indexOf('lat') == -1 || url.indexOf('lng') == -1) {
			e.preventDefault();
			ProductSearch.getLocationTriggerClick($(this));
		} else {
			location.href = url;
		}
	});
});

